// ReliabilityCTA.jsx
import React from "react";

export default function ReliabilityCTA() {
  return (
    <section className="cta" aria-label="Reliability Call to Action">
      <style>{`
        :root{A
          --bg: #fff7ed;
          --bg-2:#fde8cf;
          --text:#0b0b0b;
          --muted:#4b5563;
          --accent:#ff8a00;
          --accent-2:#ffb35c;
          --shadow: 0 16px 34px rgba(0,0,0,.14);
          --shadow-soft: 0 10px 24px rgba(0,0,0,.10);
          --radius: 14px;
        }

        *{ box-sizing:border-box; }

        .cta{
          background: linear-gradient(180deg, var(--bg) 0%, var(--bg-2) 100%);
          padding: 2.5rem 1.25rem;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
          position: relative;
          overflow: hidden;
        }

        .cta::before{
          content:"";
          position:absolute;
          inset:-2px;
          background:
            radial-gradient(600px 200px at 50% -20%, rgba(255,138,0,.18), transparent 60%),
            radial-gradient(800px 240px at 50% 120%, rgba(255,138,0,.10), transparent 60%);
          pointer-events:none;
        }

        .cta__wrap{
          max-width: 980px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .cta__icon{
          width: 34px;
          height: 64px;
          margin: 0 auto .75rem;
          display: grid;
          place-items: center;
          color: var(--accent); 
        }
        .cta__icon svg{
          width: 50px;
          height: 50px;
          fill: currentColor;
        }

        .cta__title{
          margin: 0;
          font-weight: 700;
          letter-spacing: -0.02em;
          color: var(--text);
          font-size: clamp(1.35rem, 3.6vw, 2.15rem);
          line-height: 1.15;
            font-family:'inter';
            

        }

        .cta__sub{
          margin: .75rem auto 0;
          max-width: 62ch;
          color: var(--muted);
          font-size: .92rem;
          line-height: 1.55;
               font-weight: 400;
        }

        .cta__actions{
          margin-top: 1.25rem;
          display: flex;
          justify-content: center;
        }

        .cta__btn{
          appearance:none;
          border: 0;
          // border-radius: var(--radius);
           border-radius: 8px;
          padding: .82rem 1.25rem;
          font-weight: 700;
          letter-spacing: .01em;
          cursor: pointer;
          color: #fff;
          background: linear-gradient(180deg, rgba(255,138,0,1), rgba(255,138,0,.86));
          box-shadow: 0 14px 26px rgba(255,138,0,.26), var(--shadow-soft);
          transition: transform 140ms ease, box-shadow 140ms ease, filter 140ms ease;
          min-width: 200px;
          height: 50px;
        }

        .cta__btn:hover{
          transform: translateY(-1px);
          filter: brightness(1.02);
          box-shadow: 0 18px 30px rgba(255,138,0,.28), var(--shadow);
        }

        .cta__btn:active{
          transform: translateY(0px);
        }

        .cta__btn:focus-visible{
          outline: 2px solid rgba(255,138,0,.55);
          outline-offset: 3px;
        }

        @media (max-width: 480px){
          .cta{ padding: 2.25rem 1rem; }
          .cta__btn{ width: 100%; max-width: 320px; }
        }
      `}</style>

      <div className="cta__wrap">
        <div className="cta__icon" aria-hidden="true">
          {/* eye icon */}
          <svg viewBox="0 0 24 24">
            <path d="M12 5c5.5 0 9.7 4.1 11 7-1.3 2.9-5.5 7-11 7S2.3 15 1 12c1.3-2.9 5.5-7 11-7zm0 2C7.7 7 4.2 10 3.1 12 4.2 14 7.7 17 12 17s7.8-3 8.9-5C19.8 10 16.3 7 12 7zm0 2.2A2.8 2.8 0 1112 15a2.8 2.8 0 010-5.6zm0 1.8A1 1 0 1012 13a1 1 0 000-2z" />
          </svg>
        </div>

        <h2 className="cta__title">
          Engineering reliability where <br />
          failure is not an option.
        </h2>

        <p className="cta__sub">
          Every mission-critical system we design and maintain is built with the understanding
          that defence depends on absolute reliability.
        </p>

        <div className="cta__actions">
          <button className="cta__btn" type="button">
            Contact Defence Team
          </button>
        </div>
      </div>
    </section>
  );
}
